(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimony"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('testimonialSlider');
  if (!slider) return;

  // Only apply slider behavior for tablet/mobile
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  if (isDesktop) return;

  const items = slider.querySelectorAll('.testimonies__item');
  if (items.length <= 1) return; // No need for slider with 1 item

  // Clone first item and append to end for infinite loop
  const firstItem = items[0].cloneNode(true);
  firstItem.classList.add('clone');
  slider.appendChild(firstItem);

  let currentIndex = 0;
  const itemWidth = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);
  let isAnimating = false;
  let autoScrollInterval;

  function goToSlide(index) {
    if (isAnimating) return;
    isAnimating = true;
    
    slider.style.scrollBehavior = 'smooth';
    slider.scrollTo({
      left: index * itemWidth,
      behavior: 'smooth'
    });
    
    setTimeout(() => {
      // If we're at the clone, instantly reset to first item without animation
      if (index >= items.length) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        currentIndex = 0;
      }
      isAnimating = false;
    }, 500);
  }

  function startAutoScroll() {
    autoScrollInterval = setInterval(() => {
      currentIndex++;
      goToSlide(currentIndex);
    }, 3000);
  }

  // Start auto-scrolling
  startAutoScroll();

  // Pause on hover/touch
  slider.addEventListener('mouseenter', () => {
    clearInterval(autoScrollInterval);
  });

  slider.addEventListener('mouseleave', () => {
    startAutoScroll();
  });

  // Handle touch events
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    clearInterval(autoScrollInterval);
  }, {passive: true});

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
    startAutoScroll();
  }, {passive: true});

  function handleSwipe() {
    const threshold = 50;
    if (touchStartX - touchEndX > threshold) {
      // Swipe left - next slide
      currentIndex++;
      goToSlide(currentIndex);
    } else if (touchEndX - touchStartX > threshold) {
      // Swipe right - previous slide
      currentIndex = Math.max(0, currentIndex - 1);
      goToSlide(currentIndex);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('productSlider');
  if (!slider) return;

  const items = slider.querySelectorAll('.product-card');
  if (items.length <= 1) return;

  // Clone items for infinite loop
  const cloneCount = Math.min(3, items.length);
  for (let i = 0; i < cloneCount; i++) {
    const clone = items[i].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    slider.appendChild(clone);
  }

  let currentIndex = 0;
  let isAnimating = false;
  let autoScrollInterval;
  let scrollAmount = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);

  // Update scroll amount on resize
  window.addEventListener('resize', () => {
    scrollAmount = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);
  });

  function scrollToIndex(index) {
    if (isAnimating) return;
    isAnimating = true;
    
    slider.scrollTo({
      left: index * scrollAmount,
      behavior: 'smooth'
    });

    setTimeout(() => {
      // If we're at the clones, instantly reset without animation
      if (index >= items.length) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        currentIndex = 0;
        setTimeout(() => {
          slider.style.scrollBehavior = 'smooth';
        }, 50);
      }
      isAnimating = false;
    }, 500);
  }

  function scrollNext() {
    currentIndex++;
    scrollToIndex(currentIndex);
  }

  function scrollPrev() {
    currentIndex = Math.max(0, currentIndex - 1);
    scrollToIndex(currentIndex);
  }

  // Auto-scroll every 3 seconds
  function startAutoScroll() {
    autoScrollInterval = setInterval(scrollNext, 2500);
  }

  function stopAutoScroll() {
    clearInterval(autoScrollInterval);
  }

  // Initialize auto-scroll
  startAutoScroll();

  // Pause on hover/touch
  slider.addEventListener('mouseenter', stopAutoScroll);
  slider.addEventListener('mouseleave', startAutoScroll);
  slider.addEventListener('touchstart', stopAutoScroll, { passive: true });
  slider.addEventListener('touchend', startAutoScroll, { passive: true });

  // Arrow controls
  document.querySelector('.slider-arrow.left').addEventListener('click', scrollPrev);
  document.querySelector('.slider-arrow.right').addEventListener('click', scrollNext);

  // Touch swipe support
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const threshold = 50;
    if (touchStartX - touchEndX > threshold) {
      scrollNext();
    } else if (touchEndX - touchStartX > threshold) {
      scrollPrev();
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
